import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'transactionType',
  pure: false,
  standalone: false,
})
export class TransactionTypePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: unknown, flowDirection?: boolean): string {
    if (flowDirection) {
      switch (value) {
        case 'fee_gatewee':
          return 'OUT';
        case 'fee_domain':
          return 'OUT';
        case 'fee_provider':
          return 'OUT';
        case 'cash_out':
          return 'OUT';
        case 'income':
          return 'IN';
        case 'split':
          return 'OUT';
      }
    }
    return (
      this.translate.instant(`enums.transactionType.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
